
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","stroke-linejoin":"round","d":"M9.64 11H4.745l-.001-.12c0-1.332.448-2.532 1.166-3.38M5.612 2h5.702l.001.091c0 1.047-.308 1.997-.81 2.694V6.99M8.5 11.083V15"}}),_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","d":"m2.696 1.597 11.62 11.62"}})])
          )
        }
      }
    